export default __webpack_public_path__ + "static/img/samo.2792b9e.png";